/* global FavoriteStore, Shopify */

// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSConfig.custom.products_per_page,
		/* Optional */
		loadProductFirst: false,
        capitalizeFilterOptionValues: false,
        // paginationType: boostPFSConfig.custom.pagination_type.indexOf("load_more") != -1 ? "load_more" :
		// 				(boostPFSConfig.custom.pagination_type == 'infinite_scroll' ? 'infinite' : 'default'),
	},
    selector: {
		trackingQuickView: '.quick_shop'
	}
};
// Declare Templates
var boostPFSTemplate = {
	// Grid Template
	'productGridItemHtml': '<div class="{{itemDesktopWidthClass}} category-click-element medium-down--one-half {{itemMobileWidthClass}} column {{itemQuickShopClass}} {{itemSwapImageClass}} {{itemStickersClass}}' +
						    ' thumbnail product__thumbnail product__grid-item' +
						    ' thumbnail__hover-overlay--{{itemHoverClass}}' +
						    ' has-padding-bottom">' +
						    	'<div class="product-wrap">' +
						    	    '<div class="product-image__wrapper {{itemHoverImage}}">' +
                          '{{itemTopFlags}}' +
                          '{{itemDisabledFlags}}' +
						    	        '<div class="image__container product__imageContainer">' +
						    	            '<a href="{{itemUrl}}">' +
						    	                '{{itemStickers}}' +
						    	                '{{itemImages}}' +
  												'{{itemHover}}' +
						    	            '</a>' +
						    	        '</div>' +
						    	    '</div>' +
						    	    '<div class="thumbnail__caption text-align-{{itemTextAlignClass}}">' +
						    	        '{{itemProductInfo}}' +
						    	    '</div>' +
						    	'</div>' +
						    	'{{itemSwatch}}' +
							'</div>',

	'itemHoverHtml' : '<div class="thumbnail-overlay__container">' +
						    '<a class="hidden-product-link" href="{{itemUrl}}">{{itemTitle}}</a>' +
							'{{itemProductInfoHover}}' +
							'{{itemQuickShop}}' +
						    '{{itemReviewsHover}}' +
						'</div>',

	'itemProductInfoHtml': `<div class="product-thumbnail ${Shopify.theme_settings.without_vat_class}">` +
								'{{itemVendor}}' +
                '{{itemFlags}}' +
                                '<div class="product-thumbnail__text-wrapper">' +
								'<a href="{{itemUrl}}"><p class="product-thumbnail__title">{{itemTitle}}</p>' +
                                '{{itemShortDescription}}' +
                                '</a></div>' +
                                '<div class="product-thumbnail__price-wrapper">' +
                                '{{itemAdminData}}' +
                                '{{itemReviews}}' +
                                '{{itemPrice}}' +
                                '</div>' +
                                '{{itemAvailability}}' +
                                '{{itemVariants}}' +
							'</div>',

	// Pagination Template
	'previousActiveHtml': '<a href="{{itemUrl}}" class="pagination-previous">'+ boostPFSConfig.label.previous +'</a>',
	'nextActiveHtml': '<a href="{{itemUrl}}" class="pagination-next">'+ boostPFSConfig.label.next +'</a>',
	'pageItemHtml': '<li><a class="pagination-link" href="{{itemUrl}}">{{itemTitle}}</a></li>',
	'pageItemSelectedHtml': '<li><a class="pagination-link is-current">{{itemTitle}}</a></li>',
	'pageItemRemainHtml': '<li><a class="pagination-ellipsis">…</a></li>',
	'paginateHtml': '<nav class="pagination paginate--both" role="navigation" aria-label="pagination">{{previous}}<ul class="pagination-list">{{pageItems}}</ul>{{next}}</nav>',

	// Sorting Template
	'sortingHtml': '<select aria-label="Sort by" class="sort_by">{{sortingItems}}</select>',
};

let isCollectionTypeMixed = false;
let proceeded = false;

(function () {
	BoostPFS.inject(this);

    // Build Product Grid Item
    ProductGridItem.prototype.compileTemplate = function(data, index, totalProduct) {
		if (!data) data = this.data;
   		if (!index) index = this.index;
   		if (!totalProduct) totalProduct = this.totalProduct;

        if (!proceeded) {
            const childrenArray = this.parent.children;
            let hasElectro = false;
            let hasFurniture = false;
            let isAllowedShortDescription = Shopify.theme_settings.show_description_electro ||
                Shopify.theme_settings.show_description_furniture;

            for (const child of childrenArray) {
                const isElectro = child.data.tags.includes(Shopify.translation.col_electro);
                const isFurniture = child.data.tags.includes(Shopify.translation.col_furniture);

                if (isElectro) {
                    hasElectro = true;
                }

                if (isFurniture) {
                    hasFurniture = true;
                }

                if (isAllowedShortDescription && hasElectro && hasFurniture) {
                    isCollectionTypeMixed = true;
                    break;
                }
            }

            proceeded = true;
        }

        index === 0 && $(document).trigger('boost:loading');

        setDataLayerProductObject(data);
        // Get Template
        var itemHtml = boostPFSTemplate.productGridItemHtml;

        // Add class
        var itemDesktopWidthClass = 'one-third';
        switch (boostPFSConfig.custom.products_per_row){
                case 1: itemDesktopWidthClass = 'one-whole'; break;
                case 2: itemDesktopWidthClass = 'one-half'; break;
                case 3: itemDesktopWidthClass = 'one-third'; break;
                case 4: itemDesktopWidthClass = 'one-fourth'; break;
                case 5: itemDesktopWidthClass = 'one-fifth'; break;
                case 6: itemDesktopWidthClass = 'one-sixth'; break;
                case 7: itemDesktopWidthClass = 'one-seventh'; break;
                case 8: itemDesktopWidthClass = 'one-eighth'; break;
        }
        itemHtml = itemHtml.replace(/{{itemDesktopWidthClass}}/g, itemDesktopWidthClass);
        itemHtml = itemHtml.replace(/{{itemMobileWidthClass}}/g, boostPFSConfig.custom.mobile_products_per_row == 1 ? 'small-down--one-whole' : 'small-down--one-half');
        itemHtml = itemHtml.replace(/{{itemQuickShopClass}}/g, boostPFSConfig.custom.enable_quickshop ? 'quick-shop--true quick-shop--closed product-{{itemId}} js-product_section' : '');
        itemHtml = itemHtml.replace(/{{itemStickersClass}}/g, boostPFSConfig.custom.stickers_enabled ? 'has-thumbnail-sticker' : '');
        itemHtml = itemHtml.replace(/{{itemHoverClass}}/g, boostPFSConfig.custom.thumbnail_hover_enabled.toString());
        itemHtml = itemHtml.replace(/{{itemSwapImageClass}}/g, boostPFSConfig.custom.show_secondary_image && data.images_info.length > 1 && data.variants.length == 1 ? 'swap--true' : '');
        itemHtml = itemHtml.replace(/{{itemHoverImage}}/g, boostPFSConfig.custom.show_secondary_image && data.images_info.length > 1 && data.variants.length == 1 ? 'has-secondary-image-swap' : '');
        itemHtml = itemHtml.replace(/{{itemTextAlignClass}}/g, boostPFSConfig.custom.thumbnail_text_alignment);

        // Add stickers
        var itemStickers = buildStickers(data);
        itemHtml = itemHtml.replace(/{{itemStickers}}/g, itemStickers);

        // Add images
        var itemImages = buildImages(data);
        itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImages);

        // Add hover elements
        var itemHover = buildHover(data);
        itemHtml = itemHtml.replace(/{{itemHover}}/g, itemHover);

        // Add product info
        itemHtml = itemHtml.replace(/{{itemProductInfo}}/g, boostPFSTemplate.itemProductInfoHtml);

        // Add Product Flags
        let itemTopFlags = buildTopFlags(data);
        let itemDisbaledFlags = buildDisabledFlags();
        let itemFlags = buildFlags(data);
        itemHtml = itemHtml.replace(/{{itemTopFlags}}/g, itemTopFlags);
        itemHtml = itemHtml.replace(/{{itemDisabledFlags}}/g, itemDisbaledFlags);
        itemHtml = itemHtml.replace(/{{itemFlags}}/g, itemFlags);

        // Add Short description
        var itemShortDescription = buildShortDescription(data);
        itemHtml = itemHtml.replace(/{{itemShortDescription}}/g, itemShortDescription);

        // BuildCollectionLink
        // var itemCollectionLink = buildCollectionLink(data);
        // itemHtml = itemHtml.replace(/{{itemCollectionLink}}/g, itemCollectionLink);

        // Add vendor
        var itemVendor = boostPFSConfig.custom.display_vendor ? '<span class="product-thumbnail__vendor">{{itemVendor}}</span>' : '';
        itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendor);

        var collectionHandles = data.collections.map(x => x.handle);
        // Add coming soon
        itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));

        // Add availability
        itemHtml = itemHtml.replace(/{{itemAvailability}}/g, buildAvailability(data));

        // Add variants
        itemHtml = itemHtml.replace(/{{itemVariants}}/g, buildItemVariants(data));

        // Add Saving badge
        itemHtml = itemHtml.replace(/{{savingBadge}}/g, buildSavingBadge(data));

        // Add swatch
        var itemSwatch = buildSwatch(data);
        itemHtml = itemHtml.replace(/{{itemSwatch}}/g, itemSwatch);

        // Add reviews
        itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReviews(data));

        // Add sort item and discount tags info
        let itemAdminData = '';
        if (CookiesHelper.getItem('testSort')) {
            const tags = data.tags;
            let discountTagsHtml = '';
            if (tags.length > 0){
                for (const tag of tags) {
                    if (tag.includes('BAD:') && tag.includes('★')) {
                        discountTagsHtml += tag + '<br/>';
                    }
                };
            }

            itemAdminData = '<div class="product-thumbnail__sort">'
                + 'S: <span id="product-thumbnail__sort-shopify-' + data.id + '"></span><br/>'
                + 'N: <span id="product-thumbnail__new-sort-shopify-' + data.id + '"></span><br/>'
                + 'B: ' + parseInt(data.extra_sort1) + '<br/>'
                + discountTagsHtml + '</div>';
        }
        itemHtml = itemHtml.replace(/{{itemAdminData}}/g, itemAdminData);

        // Add quick shop button placeholder
        var itemQuickShop = boostPFSConfig.custom.enable_quickshop ? '<div data-boost-pfs-quickshop-id="{{itemId}}" style="display: none"></div>' : '';
        itemHtml = itemHtml.replace(/{{itemQuickShop}}/g, itemQuickShop);

        // Add main attribute (Always put at the end of this function)
        itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
        itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
        itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
        itemHtml = itemHtml.replace(/{{itemVendor}}/g, data.vendor);
        itemHtml = itemHtml.replace(/{{itemUrl}}/g, '/products/'+ data.handle);

        return itemHtml;

        function buildReviews(data) {

        // Build Labels
            let jdgmFormated = '';
            let jdgmData = Utils.getProductMetafield(data, 'judgeme', 'badge');
            if (jdgmData !== null) {
                jdgmFormated = ProductCard.formatJdgmStarsCount(data.id, jdgmData);
            }

            return jdgmFormated;
        };
    };

    function buildStickers(data){
        var html = '';
        var stickers = [];
        if (boostPFSConfig.custom.stickers_enabled){
            var collections = data.collections.map(x => x.handle);
            var stickerCollections = ['best-seller', 'coming-soon', 'new', 'pre-order', 'staff-pick'];
            for (var i = 0; i < stickerCollections.length; i++){
                var stickerCollection = stickerCollections[i];
                if (collections.indexOf(stickerCollection) != -1){
                    var stickerText = boostPFSConfig.label[stickerCollection.replace('-', '_')];
                    var sticker = '<div class="'+ stickerCollection +'-sticker thumbnail-sticker sticker-'+ i +'"><span class="sticker-text">' + stickerText + '</span></div>';
                    stickers.push(sticker);
                }
            }

            var onSale = data.available && data.price_min < data.compare_at_price_max;
            if (onSale){
                var sticker = '<div class="sale-sticker thumbnail-sticker"><span class="sticker-text">' + boostPFSConfig.label.sale + '</span></div>';
                stickers.push(sticker);
            }

            if (stickers.length > 0){
                html = 	'<div class="sticker-holder sticker-shape-'+ boostPFSConfig.custom.sticker_shape +' sticker-position-'+ boostPFSConfig.custom.sticker_position +'">' +
                            '<div class="sticker-holder__content sticker-holder__content--">' +
                                stickers.join('') +
                            '</div>'+
                        '</div>';
            }
        }
        return html;
    }

    function RemoveAccents(str) {
      var accents    = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
      var accentsOut = "AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";
      str = str.split('');
      var strLen = str.length;
      var i, x;
      for (i = 0; i < strLen; i++) {
        if ((x = accents.indexOf(str[i])) != -1) {
          str[i] = accentsOut[x];
        }
      }
      return str.join('');
    }

    function buildImages(data){
        var html = '';
        var images = data.images_info;
        if (!images || images.length == 0){
            images.push({
                src: boostPFSAppConfig.general.no_image_url,
                width: 480,
                height: 480
            })
        }

        html += buildImageElement(images[0]);

        if (boostPFSConfig.custom.show_secondary_image && images.length > 1 && data.variants.length == 1){
            html += buildImageElement(images[1], 'lazypreload secondary swap--visible');
        }

        return html;
    }

    function buildImageElement(image, additionalClass) {
        var additionalClass = (typeof additionalClass !== 'undefined') ? additionalClass : '';
        var html = '';
        var heightStyle = '';
        var widthStyle = '';
        var aspectRatio = image.width / image.height;
        if (boostPFSConfig.custom.align_height || boostPFSConfig.custom.align_thumbnail_height){
            heightStyle += 'max-height: ' + boostPFSConfig.custom.thumbnail_height + 'px;';
            widthStyle += 'width: '+ (aspectRatio * boostPFSConfig.custom.thumbnail_height) +'px; max-width: '+ image.width +'px;';
        }

        var backgroundColor = boostPFSConfig.custom.image_loading_style == 'color' ? 'background: url('+ Utils.optimizeImage(image.src, '1x') +'); ' : '';
        var lowQualityImage = boostPFSConfig.custom.image_loading_style == 'blur-up' ? Utils.optimizeImage(image.src, '50x') : '';

        html += '<div class="image-element__wrap" style="' + backgroundColor + heightStyle + widthStyle + '">' +
                    '<img alt="{{itemTitle}}"'+
                        ' class="lazyload transition--'+ boostPFSConfig.custom.image_loading_style + ' ' + additionalClass + '"'+
                        (lowQualityImage && lowQualityImage !== '' ?
                        ' src="' + lowQualityImage + '"' : '' ) +
                        ' data-src="'+ Utils.optimizeImage(image.src, '1600x') +'"'+
                        ' data-sizes="auto"'+
                        ' data-aspectratio="' + aspectRatio +'"'+
                        ' data-srcset="' + bgset(image) +'"'+
                        ' srcset="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="' +
                        ' height="'+ image.height +'"'+
                        ' width="'+ image.width +'"'+
                        ' style="'+ heightStyle +'"'+
                    '/>' +
                '</div>';
        return html;
    }

    function buildHover(data){
        var html = '';
        if (boostPFSConfig.custom.enable_quickshop || boostPFSConfig.custom.thumbnail_hover_enabled){
            html = boostPFSTemplate.itemHoverHtml;
            if (boostPFSConfig.custom.thumbnail_hover_enabled){
                var itemProductInfoHover = 	'<div class="quick-shop__info">'+
                                                '<div class="thumbnail-overlay">'+
                                                    '<div class="info text-align-center">'+
                                                        '{{itemProductInfo}}' +
                                                    '</div>'+
                                                '</div>' +
                                            '</div>';
                html = html.replace(/{{itemProductInfoHover}}/g, itemProductInfoHover);
            } else {
                html = html.replace(/{{itemProductInfoHover}}/g, '');
                html = html.replace(/{{itemReviews}}/g, '');
            }
            if (!boostPFSConfig.custom.enable_quickshop){
                html = html.replace(/{{itemQuickShop}}/g, '');
            }
        }
        return html;
    }

    function buildSavingBadge(data) {
        let html = '';
        let discountClassName = "";
        const onSale = data.compare_at_price_max > data.price_min;
        const tags = data.tags;
        if (tags.length > 0){
            for(let tag of tags) {
                if (tag.includes("DISCOUNT")) {
                    discountClassName = tag.replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '-').replace(/:/g, "-").toLowerCase();
                }
            }
        }

        if (onSale){
            const salePercentRounded = Math.floor((data.compare_at_price_min - data.price_min) * 100 / data.compare_at_price_min);
            if (salePercentRounded >= 2) {
                html += '<div class="product__saving-badge '+ discountClassName +'"><span>' +
                            '-' + salePercentRounded +'%' +
                        '</span></div>\n';
            }
        }

        return html;
    }

    function buildShortDescription(data){
        var html = '';

        html +=  '<p class="product-thumbnail__shortdescription"></p>';

        return html;
    }

    function buildCollectionLink(data){
        var html = '';
        var tags = data.tags;

        if (tags.length > 0){

            tags.forEach(function(tag) {
                if (tag.includes("FIL:COL2")) {
                    const collectionName = tag.substring(10);
                    const collectionHandle = tag.substring(10).replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '-').toLowerCase();;
                    const collectionLink = '<a href="/collections/'+ collectionHandle +'" title="'+ collectionName +'">'+ collectionName +'</a>'

                    html +=  '<div class="product__collection-link">'+ collectionLink +'</div>';
                }
            });
        }

        return html;
    }

    function buildGiftBadge(data){
        var html = '';
        var tags = data.tags;

        if (tags.length > 0){

            tags.forEach(function(tag) {
                if (tag.includes("GIFT")) {
                    html +=  '<div class="product__free-gift">'+ Shopify.translation.free_gift +'</div>';
                }
            });
        }

        return html;
    }

    function buildTopFlags(data) {
        return '<div class="product-thumbnail__flags flags-top"></div>';
    }

    function buildDisabledFlags() {
        return '<div class="product-thumbnail__flags flags-disabled"></div>';
    }

    function buildFlags(data) {
        return '<div class="product-thumbnail__flags-container"><div class="product-thumbnail__flags flags-bottom"></div></div>';
    }

    function buildPrice(data, withAjax = true){
        /*
        Not going to do it like this for now - TODO Improvement - idea - refactoring
        using product.mf-and-data-for-collections
        and https://docs.google.com/spreadsheets/d/1wWsedDN489ThiWDCiMqUe-C3s6caYu6KF3cwo9c59hw/edit?usp=sharing
        var hasStock = null; //TODO
            var hasDeliveryDate = null; //TODO
            var hasShopDispoReservation = null; //TODO -> ajax
            the synchronicity should also be solved somehow - now it just happens to work

         */
        if (boostPFSConfig.custom.store_collection) {
            return '';
        }

        var html = '';
        var onSale = data.compare_at_price_max > data.price_min;
        var priceVaries = data.price_max != data.price_min;
        html += '<div class="product-thumbnail__price price '+ (onSale ? 'sale' : '') +'"> ';

        if (data.price_min > 0) {
            if (onSale) {
                html += '<span class="product-thumbnail__was-price was-price">' +
                    '<span class="money">'+ Utils.formatMoney(data.compare_at_price_max) +'</span>' +
                        buildSavingBadge(data) +
                    '</span>';
            }
            if (priceVaries) {
                html += '<small><em>' + boostPFSConfig.label.from + '</em></small> ';
            }
            html += '<span class="money final">' +
                Utils.formatMoney(data.price_min).replace(/([0-9]) ([0-9])/g, '$1&nbsp;$2') +
                buildPriceWithVat(data) +
                '</span>';
        } else {
            html += boostPFSConfig.custom.free_price_text;
        }
        // if (onSale){
        //     html += '<span class="sale savings">' +
        //                 boostPFSConfig.label.product_savings +'&nbsp;'+ Math.floor((data.compare_at_price_min - data.price_min) * 100 / data.compare_at_price_min) +'&nbsp;%' +
        //             '</span>\n';
        // }
        html += '</div>';
        //build price ends here

        //button placeholder - it will be replaced by the CTA on the ajaxHandle yada yada
        html += "<div id='action-button-placeholder-"+data.id+"' class='product-thumbnail__cta'></div>";

        //now solving the button - either an add to cart or a reserve button
        //must be done through AJAX to have all the data
        if (withAjax) {
            ajaxHandleActionButtonOrOOS(data);
        }

        return html;
    }

    function buildPriceWithVat(data) {
        if (Shopify.theme_settings.taxes_included) return '';

        const priceWithVat = ProductPriceByTags.getPriceWithVat(data.price_min, data);

        return '<div class="current-price-incl-vat">' +
            Utils.formatMoney(priceWithVat) +
            ` ${Shopify.translation.include_vat}</div>`;
    }

    function buildAvailability(data) {
        let html = '';
        let variantQuantity = data.quantity;
        if (variantQuantity === undefined) {
            variantQuantity = data.variants[0].inventory_quantity;
        }
        let oneOfVariantsIsInStock = variantQuantity > 0;
        if (!oneOfVariantsIsInStock && data.variants.length > 1) {
            for (const variantObject of data.variants) {
                if (variantObject.inventory_quantity > 0) {
                    oneOfVariantsIsInStock = true;
                    break;
                }
            }
        }
        html += '<div class="tags--okay" id="product-availability-'+data.id+'">';
        if (oneOfVariantsIsInStock) {
            // either they are in stock
            html += '<span class="tag in_stock">'+ boostPFSConfig.label.in_stock +'</span>';
        }
        html += '</div>';

        return html;
    }

    function buildItemVariants(data) {

        // search the group tag among all product tags
        let groupTag;
        for (let tag of data.tags) {
            if (tag.includes('GRP:')) {
                groupTag = tag;
                break;
            }
        }

        const currentMetafieldData = data.metafields.filter((data) => data.key == 'SHPF_PRD_DATA');
        if (!groupTag || currentMetafieldData.length === 0) {
            return '';
        }

        // create options of current product
        const currentProductParams = JSON.parse(currentMetafieldData[0]['value']).groups;
        if (!currentProductParams) return '';
        const currentProductGroupsCount = Object.keys(currentProductParams).length;
        let variantProducts = {},
            iconVariants = {};

        let defaultOptions = [];

        for (let group in currentProductParams) {
            for (let option in currentProductParams[group]) {
                optionValue = currentProductParams[group][option];
                if (group === 'selects') {
                    optionValue = data.id.toString();
                } else if (group === 'icons') {
                    iconVariants[option] = [];
                }
                defaultOptions.push(optionValue);
            }
        }

        // get grouped products from Boost PFS API
        const queryUrl = 'https://services.mybcapps.com/bc-sf-filter/search/',
            params = `?shop=${Shopify.routes.shop_name}&event_type=init&product_available=false&limit=70&tag=${groupTag}`;

        $.ajax({
            type: 'GET',
            url: queryUrl + params,
            success: (response) => {
                if (response.products.length === 0) return;

                // build the object of all possible variants
                for (let product of response.products) {
                    const metafieldData = product.metafields.filter((meta) => meta.key == 'SHPF_PRD_DATA');

                    if (metafieldData.length > 0) {
                        const paramsJson = JSON.parse(metafieldData[0]['value']).groups;
                        let variantOptions = [];

                        for (let group in paramsJson) {
                            for (let option in paramsJson[group]) {
                                let optionValue = paramsJson[group][option];
                                if (group === 'selects') {
                                    optionValue = product.id.toString();
                                } else if (group === 'icons' && !iconVariants[option].includes(optionValue)) {
                                    iconVariants[option].push(optionValue);
                                }
                                variantOptions.push(optionValue);
                            }
                        }
                        variantProducts[variantOptions.join(';')] = product;
                    }
                }

                // build html of all variants icons
                if (Object.keys(iconVariants).length > 0) {

                    const option = Object.keys(iconVariants)[0];
                    let iconVariantsHtml = '';

                    for (let optionValue of iconVariants[option].sort()) {
                        let variantOptions = [...defaultOptions];
                        variantOptions[0] = optionValue;

                        let variantOptionsKey = variantOptions.join(';');
                        if (typeof(variantProducts[variantOptionsKey]) === 'undefined') {
                            const similarVariants = Object.keys(variantProducts).filter((key) => key.includes(optionValue));
                            if (similarVariants.length === 0) continue;
                            variantOptionsKey = similarVariants[0];
                        }

                        const currentVariant = variantProducts[variantOptionsKey];
                        let currentVariantImage = currentVariant.featured_image ? currentVariant.featured_image : currentVariant.images['1'];

                        iconVariantsHtml += `
                            <li
                                data-sku="${currentVariant.skus[0]}"
                                class="variants__option group--icons"
                                data-value="${optionValue}"
                            >
                                <a class="variants__link" href="/products/${currentVariant.handle}">
                                    <img
                                        class="variants__option-image"
                                        src="${currentVariantImage}"
                                        title="${(option + ': ' + optionValue).replace('"', '&quot;')}"
                                    />
                                </a>
                            </li>`;
                    }

                    const iconContainer = `<ul data-option="${option}" class="variants__box">${iconVariantsHtml}</ul>`;
                    $(`[data-var-id="${data.id}"]`).append(iconContainer);
                }

                let currentColorListPositionWithItemHeight = 0,
                    lastColorListItemPosition = 0;
                if ($(`[data-var-id="${data.id}"]`).children('ul.variants__box').length) {
                    currentColorListPositionWithItemHeight = $(`[data-var-id="${data.id}"]`).children('ul.variants__box').position().top;
                    lastColorListItemPosition = $(`[data-var-id="${data.id}"]`).children('ul.variants__box').children('li.variants__option').last().position().top;
                    currentColorListPositionWithItemHeight += $(`[data-var-id="${data.id}"]`).children('ul.variants__box').children('li.variants__option').last().height();
                }
                if (currentColorListPositionWithItemHeight < lastColorListItemPosition
                        || currentProductGroupsCount > 1
                        || Object.keys(iconVariants).length == 0) {
                    // build html of "show more variants" link
                    const showMoreLink = `
                        <a class="variants__more-link" href="/products/${data.handle}">
                            + ${Shopify.translation.more_variants}
                        </a>`;
                    $(`[data-var-id="${data.id}"]`).append(showMoreLink);
                }
            }
        });

        return `<div class="variants__container--col" data-var-id="${data.id}"></div>`
    }

    function _hasDeliveryDate(deliveryDateValue) {
        return deliveryDateValue > 0 && deliveryDateValue < 999;
    }

    function ajaxHandleActionButtonOrOOS(data) {
        fetch('/products/'+ data.handle +'/?view=mf-and-data-for-collections')
        .then(response => response.json())
        .then(async (allMfData) => {
            var shopDispo = allMfData.mf_shop_dispo;
            const shopDispoHasFronts = allMfData.mf_shop_dispo_has_fronts;
            var hasShopDispoIERes = _mfShopDispoFieldNrStoresWithAvailability(shopDispo) > 0;
            var hasDeliveryDate = _hasDeliveryDate(allMfData.mf_delivery_date);
            let elementToReplace = _getAndCheckElementToReplace('#action-button-placeholder-', data, 'ajaxActionButton');
            let dataBundle = '';
            let isProductHidden = false;
            for(let tag of allMfData.tags) {
                if (tag.includes('BUNDLE-')) {
                    dataBundle = ' data-bundle="'+ tag.replace('BUNDLE-', '') +'"';
                } else if (tag.includes('PRD:Hidden') || allMfData.price_min === 0) {
                    isProductHidden = true;
                }
            }
            let oneOfVariantsIsInStock = allMfData.quantity > 0;
            if (isProductHidden) {
                oneOfVariantsIsInStock = false;
            } else if (!oneOfVariantsIsInStock && allMfData.variants.length > 1) {
                for(let variantObject of allMfData.variants) {
                    if (variantObject.inventory_quantity > 0) {
                        oneOfVariantsIsInStock = true;
                    }
                }
            }

            //only 3 cases here according to
            // specs: https://docs.google.com/spreadsheets/d/1wWsedDN489ThiWDCiMqUe-C3s6caYu6KF3cwo9c59hw/edit?usp=sharing

            let isOutOfStock = false;
            if (oneOfVariantsIsInStock == false && hasDeliveryDate == false && hasShopDispoIERes == false) {
                //only case where we should have the out of stock (OOS)
                //remove this product price from the thumbnail
                elementToReplace.parent().children(".price").empty();
                elementToReplace.closest('.product-wrap').find('.product__saving-badge').hide();
                isOutOfStock = true;
            } else if (Shopify.theme_settings.main_path_wishlist) {
                elementToReplace.html('<a href="/products/' + data.handle + '" class="button button--add-to-list">' + Shopify.translation.detail_button + '</a>');
            } else if (hasShopDispoIERes && hasDeliveryDate == false && oneOfVariantsIsInStock == false) {
                elementToReplace.html('<a href="/products/' + data.handle + '#store_on" class="button button-reservation">' + Shopify.translation.reserve_button + '</a>');
            } else {
                let properties = '';
                if (FILTER_PRODUCTS_BY_STORE) {
                    properties = await getProductStorePrice(data.handle, true);
                }
                let dataSapCategory = '';
                let dataIop = '';
                for (const productTag of allMfData.tags) {
                    if (productTag.startsWith('NOP:')) {
                        dataSapCategory = ' data-sap-category="' + productTag + '"';
                    }
                    if (productTag.startsWith('IOP:')) {
                        dataIop = ' data-iop="' + productTag + '" ';
                    }

                    if (dataSapCategory && dataIop) {
                        break;
                    }
                }
                elementToReplace.html(
                    '<a href="#"' +
                    'data-id="' + data.id + '" data-cart-add="' + data.variants[0].id + '"' +
                    'data-title="' + data.title + '" data-handle="' + data.handle + '" data-image="' + data.images_info[0].src + '"' +
                    "data-cart-properties='" + properties + "'" + dataIop +
                    'data-cart-quantity="1" class="button action_button button--add-to-cart"' + dataBundle + dataSapCategory +
                    '>' + Shopify.translation.addtocart_button + '</a>' +
                    '</div>');
            }
            const $currentThumbnailElement = $('.product__thumbnail[data-id='+ data.id +']');
            if (!isOutOfStock) {
                $currentThumbnailElement
                    .find('.product-thumbnail__price')
                    .html(`${$(buildPrice(calculateTagSalePrice(allMfData), false))[0].innerHTML}`);
                const savingBadge = buildSavingBadge(allMfData);
                if (savingBadge != '') {
                    $currentThumbnailElement
                        .find('.product__saving-badge')
                        .html(`${$(savingBadge)[0].innerHTML}`);
                }
            }

            // Build energy label
            if (allMfData.hasOwnProperty('energy_label_flag')) {
                $currentThumbnailElement.find('.product-thumbnail__flags.flags-top').append(allMfData.energy_label_flag);
            }

            const config = {
                tags: allMfData.tags,
                price: allMfData.price_min,
                priceHistory: allMfData.mf_price_history || [],
            };

            const highlightedLabelTitle = ProductCard.getHighlightedLabelText(config);
            const hasOriginZeroTag = allMfData.tags.some(tag => tag.includes('BDT:') && tag.includes('#0'));

            if (highlightedLabelTitle.length) {
                if (!hasOriginZeroTag) {
                    allMfData.tags.push('BDT:' + Shopify.translation.flags.discount_price_flag_percentage + '#0');
                }
            }

            // Build text-based product flags
            if (allMfData.tags.length > 0) {
                const [
                    rainbowTagsHtml,
                    disabledTagsHtml,
                    otherTagsHtml,
                ] = Shopify.theme.buildTextBasedFlags(allMfData.tags, { generalize: true, productAvailable: data.available });
                for (const tagHtml of rainbowTagsHtml.splice(0, 1)) {
                    $currentThumbnailElement.find('.product-thumbnail__flags.flags-top').append(tagHtml);
                }
                for (const tagHtml of disabledTagsHtml) {
                    $currentThumbnailElement.find('.product-thumbnail__flags.flags-disabled').append(tagHtml);
                }
                for (const tagHtml of otherTagsHtml.splice(0, 2)) {
                    $currentThumbnailElement.find('.product-thumbnail__flags.flags-bottom').append(tagHtml);
                }
            }

            // Add Highlighted Price Label - text depends on percentage of discount or flag (#0) issue #2315
            if (highlightedLabelTitle.length) {
                var $priceElement = $currentThumbnailElement.find('.product-thumbnail__price');
                if ($priceElement.children().length > 0) {
                    $priceElement
                        .addClass('price-label-highlighted')
                        .attr('data-before-content', `${highlightedLabelTitle}`);
                }
            }

            if ((Shopify.theme_settings.show_description_electro && data.tags.includes(Shopify.translation.col_electro)) ||
                (Shopify.theme_settings.show_description_furniture && data.tags.includes(Shopify.translation.col_furniture))
                ) {
                let productDescription = '';
                if (allMfData.short_description.length > 0) {
                    productDescription += allMfData.short_description + '. ';
                }
                if (allMfData.benefits.length > 0) {
                    productDescription += allMfData.benefits;
                }
                $("[data-id='"+ data.id +"'] .product-thumbnail__shortdescription")
                    .html(productDescription.replace(/ ([ai]|[kosuvz]|do|ke|na|od|po|se|ve|za|ze) /g, " $1&nbsp;"))
                    .css({height: 100});
            } else if (isCollectionTypeMixed) {
                // Fix layout in mixed collections
                $("[data-id='"+ data.id +"'] .product-thumbnail__shortdescription")
                    .css({height: 100});
            } else {
                $("[data-id='"+ data.id +"'] .product-thumbnail__shortdescription").remove();
            }

            if (!$('#product-availability-'+ data.id).length) {
                elementToReplace = _getAndCheckElementToReplace('#placeholder-for-delivery-text-', data, "ajaxDeliveryText" );
            } else {
                elementToReplace = $('#product-availability-'+ data.id);
            }
            const storeAvailabilityCountReservations = _mfShopDispoFieldNrStoresWithAvailability(shopDispo);

            if (CookiesHelper.getItem('testSort')) {
                const elementSort = $('#product-thumbnail__sort-shopify-'+ data.id);
                elementSort.html(allMfData.sort);
                const elementNewSort = $('#product-thumbnail__new-sort-shopify-'+ data.id);
                elementNewSort.html(allMfData.new_sort);
            }

            let reservationDeliveryText = $(_generateDeliveryTextForReservation(storeAvailabilityCountReservations, data));
            if (!oneOfVariantsIsInStock && _hasDeliveryDate(allMfData.mf_delivery_date)) {
                reservationDeliveryText = _updateReservationDeliveryText(reservationDeliveryText);
                elementToReplace.html(
                    _generateDeliveryTextForPlifs(allMfData.best_delivery_text) +
                    reservationDeliveryText.html()
                );

                updateDeliveryTextForFronts(elementToReplace, shopDispoHasFronts);
            } else {
                if (!oneOfVariantsIsInStock && storeAvailabilityCountReservations> 0) {
                    elementToReplace.html(reservationDeliveryText.html());
                } else if (!oneOfVariantsIsInStock) {
                    //let's add the sold out [TODO - improve logic here]
                    elementToReplace.html(
                        '<span class="product-thumbnail__sold-out sold-out">' +
                        boostPFSConfig.label.sold_out + '</span>'
                    );
                } else {
                    reservationDeliveryText = _updateReservationDeliveryText(reservationDeliveryText);
                    elementToReplace.html(
                        '<span class="tag in_stock">' + boostPFSConfig.label.in_stock +
                        '</span>' + reservationDeliveryText.html()
                    );

                    updateDeliveryTextForFronts(elementToReplace, shopDispoHasFronts);
                }
            }

            // disabled by https://github.com/OKAY-JENA/Okay2021/issues/3006
            // const storeAvailabilityCount = allMfData.store_count;
            // if (storeAvailabilityCount) {
            //     const storeAvailabilityText = boostPFSConfig.label.stores_availability.replace('{{ storeCount }}', allMfData.store_count);
            //     elementToReplace.append(`<br><span class="delivery-text">${storeAvailabilityText}</span>`);
            // }

            if (storage.sellerLoginExpiration) {
                let availabilityHtml = '',
                    storeDispo = null,
                    storeAvailability = 0,
                    cones = '';

                if (allMfData.hasOwnProperty('mf_store_shop_dispo') && allMfData.mf_store_shop_dispo.length > 0) {
                    storeDispo = allMfData.mf_store_shop_dispo[0];
                    if ((typeof storeDispo.COUNT) != 'undefined' && storeDispo.COUNT != '') {
                        storeAvailability = storeDispo.COUNT;
                    }

                    $currentThumbnailElement.find('.delivery-text').remove().find('.reservation-tag-pick-up').remove();

                    if (FILTER_PRODUCTS_BY_STORE) {
                        if ((typeof storeDispo.PRICE) != 'undefined' && storeDispo.PRICE != '') {
                            const price = storeDispo.PRICE;
                            if (data.compare_at_price_max <= price) {
                                $currentThumbnailElement.find('.was-price').hide();
                            }
                            $currentThumbnailElement.find('.money.final').html(Utils.formatMoney(price));
                        }

                        if ((typeof storeDispo.CONES) != 'undefined' && storeDispo.CONES != '') {
                            cones = storeDispo.CONES;
                        } else {
                            cones = '-';
                        }
                    }
                }

                if (cones == '' && allMfData.hasOwnProperty('eshop_cones') && allMfData.eshop_cones != '') {
                    cones = allMfData.eshop_cones;
                }

                availabilityHtml = availabilityHtml + sellerGetAvailabilityText(storeAvailability, 1) + '<br />';
                availabilityHtml = availabilityHtml + sellerGetAvailabilityText(allMfData.eshop_dispo, 0);

                $currentThumbnailElement.find('.tags--okay').remove();
                $currentThumbnailElement
                    .find('.product-thumbnail__price-wrapper')
                    .after(`<div class="tags--okay store-availability">${availabilityHtml}</div>`);

                if (cones != '') {
                    const conesHtml = '<span class="delivery-text">' + Shopify.translation.conesImg + ' : <span class="points">' + cones + '</span></p>';
                    $currentThumbnailElement.find('.product-thumbnail .store-availability').prepend(conesHtml);
                }
            }
        })
        .catch(function(err) {
            console.log('Fetch Error : ', err);
            $('.product__grid-item[data-id='+ data.id +']').remove();
        });
    }

    function _updateReservationDeliveryText(reservationDeliveryText) {
        reservationDeliveryText.find('.reservation-tag-pick-up').remove();
        reservationDeliveryText.find('.reservation-tag-link.not-empty').prepend(`${Shopify.translation.reservation_app.conjunction} `);

        return reservationDeliveryText;
    }

    function updateDeliveryTextForFronts(elementToUpdate, shopDispoHasFronts) {
        if (!shopDispoHasFronts) return;

        elementToUpdate.find('span').append(` ${Shopify.translation.reservation_app.conjunction} ${Shopify.translation.reservation_app.front_sample} `);
        const reservationLink = elementToUpdate.find('.reservation-tag-link.not-empty');
        reservationLink.text(reservationLink.text().substr(2));

        return elementToUpdate.html();
    }

    function _mfShopDispoFieldNrStoresWithAvailability(shopDispo) {
        var nrStoresWhereItsAvailable = 0;
        for (shopIdWithCount in shopDispo) {
            var count = shopDispo[shopIdWithCount]["COUNT"] || shopDispo[shopIdWithCount]["count"];
            if (count > 0) {
                nrStoresWhereItsAvailable++;
            }
        }
        return nrStoresWhereItsAvailable;
    }

    function _generateDeliveryTextForPlifs(plifsText) {
        return '<span class="tag on_order">'+ boostPFSConfig.label.on_order +'</span> '; // + '<span class="delivery-text on_order-color">'+ plifsText+'</span>';
    }

    function _generateDeliveryTextForReservation(nrStores, data) {
        if (nrStores < 1) {
            return '<div><span class="delivery-text reservation-tag-link"> </span></div>';
        }

        const toReturn = '<span class="tag on_order reservation-tag-pick-up">' +
            Shopify.translation.reservation_app.pick_up_immediately +
            '</span> ';

        const selectedStore = typeof FavoriteStore !== 'undefined' ? FavoriteStore.get() : null;
        const favoriteStoreIdTag = selectedStore ? 'STR:' + selectedStore.code : null;

        let shopString = '';
        let favoriteStoreAvailability = '';
        let productLink = '/products/' + data.handle;

        if (Shopify.theme_settings.enable_wishlist) {
            if (selectedStore && data.tags.includes(favoriteStoreIdTag)) {
                favoriteStoreAvailability = Shopify.translation.reservation_app.available_in_warehouse
                    .replace(/\{\{\s?title\s?}}/g, selectedStore.displayTitle);
            }
        } else {
            if (nrStores === 1) {
                shopString += Shopify.translation.reservation_app.available_in_store_singular;
            } else {
                shopString += Shopify.translation.reservation_app.available_in_stores;
            }

            shopString = shopString.replace(/\{\{\s?count\s?}}/g, nrStores);
            productLink += '#store_on';

            if (selectedStore && data.tags.includes(favoriteStoreIdTag)) {
                favoriteStoreAvailability = '<span class="favorite-store-availability">' +
                    `${Shopify.translation.including_store} ${selectedStore.displayTitle}` +
                    '</span>';
            }
        }

        return '<div>' + toReturn +
            '<a href="' + productLink + '" class="delivery-text reservation-tag-link not-empty">' +
            shopString + favoriteStoreAvailability + '</a></div>';
    }

    function _getAndCheckElementToReplace(selectorPrefix, data, idInCaseOfError) {
        const elementToReplace = $(selectorPrefix + data.id);
        if(elementToReplace.length != 1) {
            //TODO improvement - make sure these go on Sentry
            console.warn(`boost-pfs-filter|${idInCaseOfError}# elementToReplace not found ${elementToReplace.length}`);
        }
        return elementToReplace;
    }

    function buildSwatch(data){
        var html = '';
        var values = [];
        var swatchItems = [];
        if (boostPFSConfig.custom.collection_swatches){
            data.variants.forEach(function(variant){
                var colorValue = '';
                var optionValue = '';
                variant.merged_options.forEach(function(option){
                    var key = option.split(':')[0];
                    var value = option.split(':')[1];
                    if ((key.toLowerCase().indexOf('color') != -1 || key.toLowerCase().indexOf('colour') != -1
                            || key.toLowerCase().indexOf('barva') != -1 || key.toLowerCase().indexOf('dekor') != -1)
                                && values.indexOf(value.toLowerCase()) == -1){
                        values.push(value.toLowerCase());
                        colorValue = value;
                        optionValue = key;
                    }
                });
                if (colorValue){
                    var swatchItem ='<a href="{{variantUrl}}" class="swatch swatch__style--{{swatchShape}}" data-swatch-name="meta-{{slugifyOptionValue}}_{{slugifyColorValue}}">' +
                                        '<span data-image="{{variantImage}}" style="background-color: {{colorBackground}};">' +
                                            '<img class="swatch__image" src="{{colorImage}}" onerror="this.className += \' swatch__image--empty\'">' +
                                        '</span>' +
                                    '</a>';

                    swatchItem = swatchItem.replace(/{{swatchShape}}/g, boostPFSConfig.custom.collection_swatches_shape);
                    swatchItem = swatchItem.replace(/{{colorBackground}}/g, Utils.slugify(colorValue).split('-').pop());
                    swatchItem = swatchItem.replace(/{{slugifyOptionValue}}/g, Utils.slugify(optionValue).replace('-', '_'));
                    swatchItem = swatchItem.replace(/{{slugifyColorValue}}/g, Utils.slugify(colorValue).replace('-', '_'));
                    swatchItem = swatchItem.replace(/{{variantUrl}}/g, '/products/'+ data.handle +'?variant=' + variant.id);

                    var colorImage = boostPFSAppConfig.general.file_url.split('?')[0] + 'barva-' + Utils.slugify(colorValue) + '_50x.png';
                    swatchItem = swatchItem.replace(/{{colorImage}}/g, colorImage);

                    var variantImage = '';
                    var noImageClass = '';
                    if (variant.image){
                        switch (boostPFSConfig.custom.products_per_row){
                            case 2: variantImage = Utils.optimizeImage(variant.image, '600x'); break;
                            case 3: variantImage = Utils.optimizeImage(variant.image, '500x'); break;
                            default: variantImage = Utils.optimizeImage(variant.image, '400x'); break;
                        }
                    }
                    swatchItem = swatchItem.replace(/{{variantImage}}/g, variantImage);
                    swatchItems.push(swatchItem);
                }
            })
        }
        if (swatchItems.length > 1){
            html = '<div class="thumbnail-swatch is-flex-wrap">' +
                        swatchItems.join(' ') +
                    '</div>';
        }
        return html;
    }

    function bgset(image){
        var bgset = '';
        if (image) {
            var aspect_ratio = image.width / image.height;

            if (image.width > 180) bgset += ' ' + Utils.optimizeImage(image.src, '180x') + ' 180w ' + Math.round(180 / aspect_ratio) + 'h,';
            if (image.width > 360) bgset += ' ' + Utils.optimizeImage(image.src, '360x') + ' 360w ' + Math.round(360 / aspect_ratio) + 'h,';
            if (image.width > 540) bgset += ' ' + Utils.optimizeImage(image.src, '540x') + ' 540w ' + Math.round(540 / aspect_ratio) + 'h,';
            if (image.width > 720) bgset += ' ' + Utils.optimizeImage(image.src, '720x') + ' 720w ' + Math.round(720 / aspect_ratio) + 'h,';
            if (image.width > 900) bgset += ' ' + Utils.optimizeImage(image.src, '900x') + ' 900w ' + Math.round(900 / aspect_ratio) + 'h,';
            if (image.width > 1080) bgset += ' ' + Utils.optimizeImage(image.src, '1080x') + ' 1080w ' + Math.round(1080 / aspect_ratio) + 'h,';
            if (image.width > 1296) bgset += ' ' + Utils.optimizeImage(image.src, '1296x') + ' 1296w ' + Math.round(1296 / aspect_ratio) + 'h,';
            if (image.width > 1512) bgset += ' ' + Utils.optimizeImage(image.src, '1512x') + ' 1512w ' + Math.round(1512 / aspect_ratio) + 'h,';
            if (image.width > 1728) bgset += ' ' + Utils.optimizeImage(image.src, '1728x') + ' 1728w ' + Math.round(1728 / aspect_ratio) + 'h,';
            if (image.width > 1950) bgset += ' ' + Utils.optimizeImage(image.src, '1950x') + ' 1950w ' + Math.round(1950 / aspect_ratio) + 'h,';
            if (image.width > 2100) bgset += ' ' + Utils.optimizeImage(image.src, '2100x') + ' 2100w ' + Math.round(2100 / aspect_ratio) + 'h,';
            if (image.width > 2260) bgset += ' ' + Utils.optimizeImage(image.src, '2260x') + ' 2260w ' + Math.round(2260 / aspect_ratio) + 'h,';
            if (image.width > 2450) bgset += ' ' + Utils.optimizeImage(image.src, '2450x') + ' 2450w ' + Math.round(2450 / aspect_ratio) + 'h,';
            if (image.width > 2700) bgset += ' ' + Utils.optimizeImage(image.src, '2700x') + ' 2700w ' + Math.round(2700 / aspect_ratio) + 'h,';
            if (image.width > 3000) bgset += ' ' + Utils.optimizeImage(image.src, '3000x') + ' 3000w ' + Math.round(3000 / aspect_ratio) + 'h,';
            if (image.width > 3350) bgset += ' ' + Utils.optimizeImage(image.src, '3350x') + ' 3350w ' + Math.round(3350 / aspect_ratio) + 'h,';
            if (image.width > 3750) bgset += ' ' + Utils.optimizeImage(image.src, '3750x') + ' 3750w ' + Math.round(3750 / aspect_ratio) + 'h,';
            if (image.width > 4100) bgset += ' ' + Utils.optimizeImage(image.src, '4100x') + ' 180w ' + Math.round(4100 / aspect_ratio) + 'h,';
            bgset += ' ' + image.src + ' ' + image.width + 'w ' + image.height + 'h,';
        }
        return bgset;
    }

    // Build Pagination
    ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
      	if (!totalProduct) totalProduct = this.totalProduct

        // Get page info
        var currentPage = parseInt(Globals.queryParams.page);
        var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

        if (Settings.getSettingValue('general.paginationType') == 'default' && totalPage > 1) {
            var paginationHtml = boostPFSTemplate.paginateHtml;
            // Build Previous
            var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
            previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
            paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
            // Build Next
            var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
            nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
            paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
            // Create page items array
            var beforeCurrentPageArr = [];
            for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
                beforeCurrentPageArr.unshift(iBefore);
            }
            if (currentPage - 4 > 0) {
                beforeCurrentPageArr.unshift('...');
            }
            if (currentPage - 4 >= 0) {
                beforeCurrentPageArr.unshift(1);
            }
            beforeCurrentPageArr.push(currentPage);
            var afterCurrentPageArr = [];
            for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
                afterCurrentPageArr.push(iAfter);
            }
            if (currentPage + 3 < totalPage) {
                afterCurrentPageArr.push('...');
            }
            if (currentPage + 3 <= totalPage) {
                afterCurrentPageArr.push(totalPage);
            }
            // Build page items
            var pageItemsHtml = '';
            var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
            for (var iPage = 0; iPage < pageArr.length; iPage++) {
                if (pageArr[iPage] == '...') {
                    pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
                } else {
                    pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
                }
                pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
                pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
            }
            paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
            return paginationHtml;
        }

        return '';
    };

    // Build Sorting
    ProductSorting.prototype.compileTemplate = function () {
        if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
            var sortingArr = Utils.getSortingList();
            if (sortingArr) {
                // Build content
                var sortingItemsHtml = '';
                for (var k in sortingArr) {
                    if (sortingArr[k] !== undefined) {
                        sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
                    }
                }
                var html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
                return html;
            }
        }
        return '';
    };

    // Add additional feature for product list, used commonly in customizing product list
    ProductList.prototype.afterRender = function(data, eventType) {
      	if (!data) data = this.data
        if (!eventType) eventType = this.eventType

        if (boostPFSConfig.custom.enable_quickshop && data.length > 0) {
            var count = 0;
            data.forEach(function(product) {
                var url = Utils.buildProductItemUrl(product, true);
                jQ.ajax({
                    type: "GET",
                    url: url + '?view=boost-pfs-quickview',
                    success: function (result) {
                        if (jQ('[data-boost-pfs-quickshop-id="'+ product.id + '"]').length == 1){
                            jQ('[data-boost-pfs-quickshop-id="'+ product.id + '"]').replaceWith(result);
                        }
                        count++;
                        if (count == data.length){
                            buildTheme();
                        }
                    }
                });
            })
        } else {
            buildTheme();
        }
        pushDataLayerImpressions();

        const boostMobileFilterButton = document.querySelector('.boost-pfs-filter-tree-mobile-button');
        const containerFilterResults = document.querySelector('.mobile-filter_results');

        if (containerFilterResults && boostMobileFilterButton) {
            setTimeout (()=> {
                containerFilterResults.innerHTML = '';
                const boostFilterResults = document.querySelectorAll('.boost-pfs-filter-refine-by-items button');
                boostFilterResults.forEach(btn => {
                    const cloneElm = btn.cloneNode(true);
                    cloneElm.classList.add('mobile-filter_value')
                    cloneElm.addEventListener('click', () => btn.click());
                    containerFilterResults.appendChild(cloneElm);
                });
            }, 1000);
        }
    };

    function createCategoryLinks(options)
    {
        $.each(options, (index, option) => {
            if ('filterOptionId' in option && option.filterOptionId == 'pf_t_kategorie'
                    && 'values' in option && option.values.length > 0) {
                if (!$('#category-filter-buttons').length) {
                    $('.filter-sticky-wrapper').before('<div class="container" id="category-filter-buttons"></div>');
                }
                let categoryLinkButtons = '';
                let categoryLinkName = '';
                let categoryLinkUrl = '';
                $.each(option.values, (valueIndex, optionValues) => {
                    categoryLinkName = optionValues.key.replace('COL2HK:', '');
                    categoryLinkUrl = categoryLinkName.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '-').toLowerCase();
                    console.log(categoryLinkName.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '-').toLowerCase());
                    categoryLinkButtons += '<a href="/collections/'+ categoryLinkUrl +'">'+ categoryLinkName +'</a>';
                    console.log(optionValues)
                });
                $('#category-filter-buttons').html(categoryLinkButtons);
                // console.log(option.values);
                return;
            }
        });
    }

    function setDataLayerProductObject(data)
    {
        if (data.id in dataLayerProductObjects) {
            dataLayerCurrentPageProductObjects[data.id] = dataLayerProductObjects[data.id];
        } else {
            const resultSSID = data.tags.filter(option => option.startsWith('SSID:'+ data.variants[0].id));
            const shopifyId = data.variants[0].id;
            let shopsysId = shopifyId;
            if (resultSSID.length > 0) {
                const SSID = resultSSID[0].replace(/^SSID:[^-]+-/, '');
                if (/^[0-9]+$/.test(SSID)) {
                    shopsysId = parseInt(SSID);
                }
            }
            dataLayerProductObjects[data.id]
                = dataLayerCurrentPageProductObjects[data.id] = {
                    'name': data.title,
                    'id': shopsysId,
                    'shopifyId': shopifyId,
                    'priceWithTax': data.price_min,
                    'price': parseFloat((data.price_min / (Shopify.theme_settings.shop_vat + 1)).toFixed(2)),
                    'tax': parseFloat((data.price_min / (Shopify.theme_settings.shop_vat + 1) * Shopify.theme_settings.shop_vat).toFixed(2)),
                    'brand': data.vendor,
                    'category': data.product_type,
                    'variant': data.variants[0].title,
                    'sku': data.variants[0].sku,
                    ...ProductUtils.getSapCategories(data.tags),
                }
        }
    }

    function pushDataLayerImpressions() {
        let impressionsObject = {
            'event': 'ec.impressions',
            'ecommerce': {
                'currencyCode': boostPFSAppConfig.shop.currency,
                'impressions': undefined,
            }
        };
        const impressionsObjectClone = JSON.parse(JSON.stringify(impressionsObject));
        dataLayer.push(impressionsObjectClone);
        impressionsObject.ecommerce.impressions = [];

        let currentProductInSearchingPosition = 0;
        let dataLayerProductObject;
        for(let productId in dataLayerCurrentPageProductObjects) {
            dataLayerProductObject = { ...dataLayerProductObjects[productId] };
            if ($('#shopify-section-search__main').length > 0) {
                dataLayerProductObject.list = 'Search Results';
            }
            dataLayerProductObject.position = ++currentProductInSearchingPosition;
            impressionsObject.ecommerce.impressions.push(dataLayerProductObject);
        }
        dataLayer.push(impressionsObject);
        dataLayerCurrentPageProductObjects = {};
    }

    // Build additional elements
    FilterResult.prototype.afterRender = function() {
        if ($.inArray(this.eventType, ['filter', 'clear', 'clearAll']) >= 0) {
            $(document).trigger('afterRenderFilterCallback');
        }
    };

    function buildTheme(){
        if (window.SPR) {
            SPR.initDomEls();
            SPR.loadBadges();
        }
      if (typeof Shopify.PaymentButton !== 'undefined') {
        Shopify.PaymentButton.init();
      }

        if (boostPFSConfig.custom.show_multiple_currencies) {
            convertCurrencies();
        }
    }

    FilterOptionItem.prototype.buildLabel = function() {
		var filterOption = this.filterOption ? this.filterOption : this.parent;

		var label = Utils.stripHtml(this.label);
		var prefix = filterOption.prefix;

		if (typeof label != 'string') return '';

		// Remove Prefix
		if (typeof prefix == 'string') {
			prefix = prefix.replace(/\\/g, '');
          	label = label.replace(/&#x2F;/g, '/').trim();
			label = label.replace(prefix, '').trim();
		}

		// No capital label of Rating filter option
		if (label.indexOf('boost-pfs-filter-icon-star') > -1) return label;

		// Make the text to uppercase
		filterOption.displayAllValuesInUppercaseForm = filterOption.displayAllValuesInUppercaseForm || false;
		if (filterOption.displayAllValuesInUppercaseForm) return label.toUpperCase();

		// Make all letters lowercase first, then capitalize all first letters of each string in a filter option value
		// For example: HELLO World => Hello World
		if (Settings.getSettingValue('general.forceCapitalizeFilterOptionValues')) return Utils.capitalize(label, true);

		// Make all letters lowercase first, then capitalize first letter of a filter option value
		// For example: product fILTER => Product filter
		if (Settings.getSettingValue('general.capitalizeFirstLetterFilterOptionValues')) return Utils.capitalize(label, true, true);

		// Just capitalize first letter and don't change the format of any other letters
		// For example: hello wORLD => Hello WORLD
		if (Settings.getSettingValue('general.capitalizeFilterOptionValues')) return Utils.capitalize(label);

		// return label
		return Utils.stripHtml(label);
	};

    FilterOptionItemMultiLevelTag.prototype.onApplyFilter = function() {
        if(this.level === 1){
            this.onClickToggle()
            return
        }
        // If this is selected, and select type is single, do nothing
        if (this.isSelected && this.filterOption.selectType == FilterOptionEnum.SelectType.SINGLE) {
            // Expand the children
            if (this.children && this.children.length > 0) {
                this.$itemElement.addClass('boost-pfs-open');
                FilterOptionItemMultiLevelTag.setLevelOpenStateData(this, true);
            }
            return;
        }

        // Expand the children after filtering
        if (this.children && this.children.length > 0) {
            FilterOptionItemMultiLevelTag.setLevelOpenStateData(this, true);
        }

        var filterOptionId = this.filterOption.filterOptionId;

        // Toggle the selected state
        this.isSelected = !this.isSelected;

        // The values array to send to API
        var values = null;

        // If single option, set or clear the value based on selected state
        if (this.filterOption.selectType == FilterOptionEnum.SelectType.SINGLE) {
            values = this.isSelected ? [this.value] : [];

        // If multiple option, remove or add the new value based on selected state
        } else {

        // Get existing value(s)
            values = Globals.queryParams[filterOptionId];
            if (!Array.isArray(values)){
                values = [];
            }

            if (this.isSelected) {
                // Add new value to existing values array
                if (!values.includes(this.value)) {
                    values.push(this.value);
                }
            } else {
                // Remove value from existing values array
                values = values.filter(x => x !== this.value);
            }
        }
        FilterApi.setParam(filterOptionId, values);
        FilterApi.setParam(filterOptionId + '_and_condition', this.filterOption.useAndCondition && values.length > 0 ? true : null);

        // Reset the page param
        FilterApi.setParam('page', 1);

        var eventType = 'filter';
        var eventInfo = {
            filterOptionId: filterOptionId,
            filterValue: this.value
        }

        FilterApi.applyFilter(eventType, eventInfo);
    }

    Utils.formatMoney = function(money, format, withoutTrailingZeros) {
        if (typeof format == 'undefined') format = Globals.moneyFormat;
        if (format == 'money_with_currency' || Settings.getSettingValue('general.moneyFormatWithCurrency')) format = Globals.moneyFormatWithCurrency;
        if (typeof withoutTrailingZeros == 'undefined') var withoutTrailingZeros = false;
        // if (typeof Shopify.formatMoney === 'function') { return Shopify.formatMoney(money, format); }
        if (typeof money == 'string') {
          money = money.replace('.', '');
        }
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = format || '${{amount}}';

        function defaultOption(opt, def) {
          return (typeof opt == 'undefined' ? def : opt);
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultOption(precision, 2);
          thousands = defaultOption(thousands, ',');
          decimal = defaultOption(decimal, '.');
          if (isNaN(number) || number == null) {
            return 0;
          }
          number = parseFloat(number).toFixed(precision);
          var parts = number.split('.');
          var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
          var money = parts[1] ? (decimal + parts[1]) : '';
          return withoutTrailingZeros == true ? (dollars + money).replace(/((\,00)|(\.00))$/g, '') : dollars + money;
        }

        var matches = formatString.match(placeholderRegex);
        var match = matches && matches.length > 1 ? matches[1] : '';
        switch (match) {
          case 'amount':
            value = formatWithDelimiters(money, 2);
            break;
          case 'amount_no_decimals':
            value = formatWithDelimiters(money, 0);
            break;
          case 'amount_with_comma_separator':
            value = formatWithDelimiters(money, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(money, 0, '.', ',');
            break;
          case 'amount_with_space_separator_no_comma':
            value = formatWithDelimiters(money, 2);
            break;
          case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(money, 0, ' ');
            break;
          case 'amount_with_space_separator':
            value = formatWithDelimiters(money, 2, ' ', ',');
            break;
          default:
            value = formatWithDelimiters(money, 2);
            break;
        }
        formatString = formatString.replace(placeholderRegex, value);

        if (Settings.getSettingValue('general.enable3rdCurrencySupport')) {
          return Utils.moneyWrapper(formatString);
        } else {
          return formatString;
        }
    };
})();


/* Begin patch boost-010 run 2 */
Filter.prototype.beforeInit=function(){var t=this.isBadUrl();t&&(this.isInit=!0,window.location.href=window.location.pathname)},Filter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var n=0;n<t.length;n++){var i=t[n],r=(i.match(/</g)||[]).length,a=(i.match(/>/g)||[]).length,o=(i.match(/alert\(/g)||[]).length,h=(i.match(/execCommand/g)||[]).length;if(r>0&&a>0||r>1||a>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */

if (location.href.indexOf('search?') == -1) {
    const collectionDescriptionElement = $('.collection__description').closest('.container');
    let collectionDescriptionHTML = null;
    if (collectionDescriptionElement.length) {
        collectionDescriptionHTML = collectionDescriptionElement[0].innerHTML;
    }
    if (location.href.indexOf('page=') > 0) {
        collectionDescriptionHTML ? collectionDescriptionElement.html('') : null;
    }
    $(document).on('click', '.boost-pfs-filter-bottom-pagination nav.pagination a', (e) => {
        if (location.href.indexOf('page=') == -1) {
            $('meta[name=robots]').attr('content', 'index,follow');
            collectionDescriptionHTML ? collectionDescriptionElement.html(collectionDescriptionHTML) : null;
        } else {
            collectionDescriptionHTML ? collectionDescriptionElement.html('') : null;
        }
    });
}

$(document).on('click', '.boost-pfs-filter-bottom-pagination nav.pagination a', (e) => {
    setTimeout(() => {
        let topOffset = $('.collection-matrix__wrapper').offset().top - 90;
        $(document).scrollTop(topOffset);
    }, 200);
});

// Start Boost 145171
FilterTree.prototype.afterBindEvents = function() {
    const isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream && !!navigator.platform.match(/iPhone|iPod|iPad/);

    if (isiOS) {
        const filterOptionsContentInner = document.querySelectorAll('.boost-pfs-filter-option-content-inner');
        for (const elm of filterOptionsContentInner) {
            elm.style.maxHeight = '-webkit-fill-available';

            const elmWrapper = elm.closest('.boost-pfs-filter-option-content');
            if (elmWrapper.classList.contains('boost-pfs-filter-has-searchbox')) {
                elm.style.paddingBottom = '35px';
            }

            const elmViewMoreButton = elmWrapper.querySelector('.boost-pfs-filter-option-view-more-action');
            if (elmViewMoreButton) {
                const styleOverride = document.createElement('style');
                styleOverride.innerHTML = `#${elmWrapper.getAttribute('id')} .boost-pfs-filter-option-item { display: block !important;}`;
                elm.appendChild(styleOverride);
                elmViewMoreButton.style.display = 'none';
            }
        }
    }
};

function appendFilterItemsOnToggleFilterOption() {
    if (!this.collapse.isCollapsed) {
        const scrollbar = this.scrollbar;
        if (scrollbar.numberFilterItemsRendered != this.filterItems.size) {
            scrollbar.appendFilterItems();
        }
    }
}

FilterOption.prototype.afterRender = function() {
    if (this.$filterOptionTitleElement) {
        this.$filterOptionTitleElement[0].addEventListener("click", appendFilterItemsOnToggleFilterOption.bind(this));
    }
};

FilterScrollbar.prototype.isScrollToBottom = function() {
    if (this.$scrollElement) {
        return this.$scrollElement[0].scrollHeight - this.$scrollElement[0].scrollTop - this.$scrollElement.outerHeight() < 1;
    }
    return false;
};
// END Boost 145171

// Overwrite standard behavior if boost is unavailable (fix sorting) - git #1117
Filter.prototype.errorFilterCallback = function() {
    if (!Utils.isiOS() && !Utils.isSafari() && !Utils.isBackButton()
        && !Utils.getWindowLocation().href.includes('view=boost-pfs-original')) {
        const url = Utils.getWindowLocation().href.split("?")[0];
        const searchQuery = (Utils.isSearchPage() && Globals.queryParams.hasOwnProperty('q'))
            ? '&q=' + Globals.queryParams.q
            : '';
        const newUrl = url + '?view=boost-pfs-original' + '&sort_by=best-selling' + searchQuery;

        if (!Utils.isBadUrl(newUrl)) {
            window.location.href = newUrl;
        }
    }
};

FilterApi.beforeCall = function() {
    Globals.queryParams.q = Utils.getParam(Globals.searchTermKey);
};

FilterApi.afterCall = (e) => {
    if ('products' in e && !e.products.length) {
        emptyBoostResponseRecoBlocks();
    }
};

const emptyBoostResponseRecoBlocks = () => {
    generateRelatedRecoBlock();
    generateElectroRecoBlock();
    generateFurnitureRecoBlock();
};

const generateRecoBlock = (recoName, recoHeading, recoSize, boostSearchUrl) => {
    boostSearchUrl.searchParams.set('shop', Shopify.routes.shop_name);
    boostSearchUrl.searchParams.set('limit', recoSize);
    boostSearchUrl.searchParams.set('product_available', 'true');
    boostSearchUrl.searchParams.set('event_type', 'init');
    boostSearchUrl.searchParams.set('sort_first', 'available');
    boostSearchUrl.searchParams.set('sort_first_mode', 'desc');
    boostSearchUrl.searchParams.set('sort', 'price-descending');
    // boostSearchUrl.searchParams.set('fuzzy', 'false');
    const $searchContent = document.getElementsByClassName('search__content')[0];
    $searchContent.insertAdjacentHTML(
        'beforeend',
        `<div id="reco--okay-${recoName}" class="reco--okay" style="display: none;"></div>`
    );

    fetch(boostSearchUrl.toString())
        .then(response => response.json())
        .then(async (data) => {
            if (data.products.length > 0) {
                const showCta = true;
                if (typeof RecoBlock === 'undefined') {
                    await new Promise((resolve) => {
                        const interval = setInterval(() => {
                            if (typeof RecoBlock !== 'undefined') {
                                clearInterval(interval);
                                resolve();
                            }
                        }, 100);
                    });
                }
                new RecoBlock({
                    products: data.products,
                    currentProduct: null,
                    recoName: recoName,
                    recoHeading: recoHeading,
                    numberOfProducts: recoSize,
                    additionalClasses: '',
                    initialIndex: Shopify.media_queries.large.matches ? 10 : 0,
                    showCta: showCta
                });

                if (showCta) {
                    const moreButton = `
                                    <div id="${recoName}-more" class="has-padding-bottom text-align-center">
                                        <a href="${Shopify.routes.search_url + '?' + boostSearchUrl.searchParams}" class="pagination-next">
                                            Zobrazit více produktů
                                        </a>
                                    </div>`;

                    // make sure that the button is appended after the reco is created
                    $(document).one(`${recoName}:created`, () => {
                        $(`#reco--okay-${recoName}`).append(moreButton);
                    });
                }
            }
        })
        .catch((data) => {
            console.error(data);
        });
};

const generateRelatedRecoBlock = () => {
    const recoName = 'empty-boost-related';
    const recoHeading = Shopify.translation.related_products;
    const recoSize = 50;
    const boostSearchUrl = new URL(Shopify.theme_settings.reco_block_query_url);

    const searchTerm = Utils.getParam(Globals.searchTermKey)?.replaceAll(' ', ' OR ');
    if (searchTerm) {
        boostSearchUrl.searchParams.set('q', searchTerm);
        generateRecoBlock(recoName, recoHeading, recoSize, boostSearchUrl);
    }
}

const generateElectroRecoBlock = () => {
    const recoName = 'empty-boost-electro';
    const recoHeading = Shopify.translation.staff_pick_electro;
    const recoSize = 50;
    const boostSearchUrl = new URL(Shopify.theme_settings.reco_block_query_url);
    boostSearchUrl.searchParams.set('tag', Shopify.translation.iop_electro);
    boostSearchUrl.searchParams.append('tag', 'PRD:New');

    generateRecoBlock(recoName, recoHeading, recoSize, boostSearchUrl);
}

const generateFurnitureRecoBlock = () => {
    const recoName = 'empty-boost-furniture';
    const recoHeading = Shopify.translation.staff_pick_furniture;
    const recoSize = 50;
    const boostSearchUrl = new URL(Shopify.theme_settings.reco_block_query_url);
    boostSearchUrl.searchParams.set('tag', Shopify.translation.iop_furniture);
    boostSearchUrl.searchParams.append('tag', 'PRD:New');

    generateRecoBlock(recoName, recoHeading, recoSize, boostSearchUrl);
}
